import React, { useEffect, useState, useRef } from 'react';
import useForceUpdate from 'use-force-update';
import { isNumber } from '../../Utils/Common';
import PropagateLoader from "react-spinners/PropagateLoader";
// import { biometricDataToJson } from '../../Utils/function';
import { POST_AEPS_BALANCE_ENQUIRY, /* BIOMETRIC_CAPTURE_API, BIOMETRIC_CAPTURE_XML_DATA */ } from '../../Utils/appConstants';
import { postRequest } from '../../Utils/AppApi';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import Select from 'react-select';
import xmlJs from 'xml-js';
import axios from 'axios';
import { Checkbox, Button } from 'antd';
import PartnerEkyc from './../../container/partnerEkyc';
import BioDevice from './bioDevice';
// import moment from 'moment';
// const user = getUser();
function BalanceEnquiry(props) {
    // console.log("existData------", props.existData)
    const history = useHistory();
    const forceUpdate = useForceUpdate();
    const [isLoading, setLoading] = useState(false);
    const [getDataField, setDataField] = useState(props.existData ? props.existData : []);
    const [getDataError, setDataError] = useState({});
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [isConsent, setConsent] = useState("N");
    const [biometricData, setBiometricData] = useState(null);
    const [getBankList, setBankList] = useState([]);
    const [isSubmit, setSubmit] = useState(false);
    // const [defaultValue, setDefaultValue] = useState(null)
    const [fingerprintXmlData, setFingerprintXmlData] = useState(null)

    const [status, setStatus] = useState(null);
    const [statusMessage, setStatusMessage] = useState(null);
    const aadharInput = useRef("");
    const mobileInput = useRef("");

    // const getBankListData = async () => {
    //     await getNewRequest(GET_AEPS_BANK_LIST, history).then((response) => {
    //         if (response.success === true) {
    //             setBankList(response.data.map(item => {
    //                 return { "value": item.iin, "label": item.name };
    //             }));
    //         } else {
    //             toast.error(response.message);
    //         }
    //     }).catch(function (error) {
    //         console.log(error)
    //         // setLoading(false);
    //     })
    // }

    const onChangeValueSelect = (event) => {
        const { value } = event;
        // console.log("value ----------",value)
        props.existInputData(event, value);
        setDataField({ ...getDataField, "bankiin": value });
    }

    const clearFormField = () => {
        props.clearExistInputData();
        setConsent('N');
        setSubmit(false)
        // setDefaultValue(null);
        // mobileInput.current.value = "";
        // aadharInput.current.value = "";
        setDataError({});
        setDataField([])
    }

    const onChangeValue = (event) => {
        props.existInputData(event);
        const { name, value } = event.target;
        setDataField({ ...getDataField, [name]: value });
    }

    const FormValidate = () => {
        let formValid = true;
        let formObject = {};
        setDataError({})
        if (getDataField && getDataField.length === 0) {
            formValid = false;
        }
        let array = ["bankiin", "aadhaar", "mobile"];
        array.forEach(element => {
            if (getDataField[element] === "" || typeof getDataField[element] === "undefined") {
                formObject[element] = true;
                formValid = false;
            }
        });

        if (isConsent === 'N') {
            toast.error("Please aadhaar accept consent declaration");
            formValid = false;
        }

        setDataError(formObject);
        return formValid;
    }

    const scanFingerPrintData = async () => {
        await axios({
            method: 'CAPTURE',
            url: props.deviceConfig.captureUrl,
            headers: { "Content-Type": "text/xml; charset=UTF-8" },
            data: props.deviceConfig.xmlData
        }).then(response => {
            console.log("00----------------------", response.data)
            const jsonData = xmlJs.xml2json(response.data, { compact: true, spaces: 4 });
            let XMLjson = JSON.parse(jsonData);

            if (XMLjson && XMLjson.PidData.Resp._attributes.errCode !== "700") {
                setFingerprintXmlData(response.data)
            } else {
                setFingerprintXmlData(null)
            }
        }).catch(error => {
            console.log("error -----------", error)
        })
    }

    const scanFinger = () => {
        // console.log('-------------', FormValidate());
        if (FormValidate()) {
            // console.log('-------------', FormValidate());
            scanFingerPrintData();
        }
    }

    const handleSubmit = () => {
        setLoading(true)
        const payload = {
            bankiin: getDataField.bankiin,
            mobile: getDataField.mobile,
            biometricData: biometricData,
            aadhaar: getDataField.aadhaar,
            latitude: latitude,
            isXml: true,
            longitude: longitude,
            consent: isConsent
        }

        postRequest(POST_AEPS_BALANCE_ENQUIRY, payload, history).then((response) => {
            if (response.success === true) {
                setStatus(1)
                setStatusMessage('Account Balance is : ' + response.data.bankAccountBalance)
                toast.success(response.message);
            } else {
                setStatus(0)
                setStatusMessage(response.message)
                toast.error(response.message);
            }
            setLoading(false)
            setSubmit(true)
        })
    } // eslint-disable-line react-hooks/exhaustive-deps

    const onChangeChackBox = (e) => {
        if (e.target.checked === true) {
            setConsent('Y')
        } else {
            setConsent('N')
        }
    };

    useEffect(() => {
        if (fingerprintXmlData) {
            // console.log("fingerprint ---", fingerprintXmlData)
            // let data = biometricDataToJson(fingerprintXmlData)
            setBiometricData(fingerprintXmlData)
        }
    }, [fingerprintXmlData]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        // getBankListData();
        navigator.geolocation.getCurrentPosition((data) => {
            setLatitude(data.coords.latitude)
            setLongitude(data.coords.longitude)
        });
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        return () => {
            setSubmit(false)
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (props.existData) {
            forceUpdate();
        }
    }, [props.existData])  // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        // console.log("call cash withdrawal api ---")
        if (biometricData) {
            handleSubmit();
        }
        if (props.getBankList && props.getBankList.length > 0) {
            setBankList(props.getBankList)
        }
    }, [biometricData, props.getBankList]) // eslint-disable-line react-hooks/exhaustive-deps

    if (isLoading) {
        return <div className="content text-center" style={{ margin: "250px 0" }}>
            <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
        </div>
    }

    return (
        <div>
            <div className="row">
                <div className="col-md-12">
                    <div className='card rounded-0 card-body'>
                        {isSubmit ? <>
                            <div className='text-right'>
                                <Button className='bg bg-primary mr-3' onClick={() => props.subChangeTab('1')}>Cash Withdrawal</Button>
                                <Button className='bg bg-primary mr-3' onClick={() => clearFormField()}>New Transaction</Button>
                                <Button className='bg bg-info' onClick={() => scanFinger()}>Retry</Button>
                            </div>
                            <PartnerEkyc status={status} message={statusMessage} />
                        </> :
                            <div className='row'>
                                <div className='col-sm-6 col-md-4 col-lg-4'>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <label>Bank Name</label>
                                            <Select showSearch status={`${getDataError && getDataError.bankiin ? "in-valid" : ""}`} options={getBankList} className={`normal-light w-100`} classNamePrefix="select" name='bankiin' onChange={(e) => onChangeValueSelect(e)} placeholder="-Select Bank-" />
                                            {getDataError && getDataError.bankiin && <span className="error text-danger">The field is required</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-sm-6 col-md-4 col-lg-4'>
                                    <div className="form-group">
                                        <label>Aadhaar Number</label>
                                        <input type="text" className={`form-control normal-light ${getDataError && getDataError.aadhaar ? "is-invalid" : ""}`} name="aadhaar" maxLength={12} value={getDataField && getDataField.aadhaar} onKeyDown={isNumber} onChange={(e) => onChangeValue(e)} ref={aadharInput} />
                                        {getDataError && getDataError.aadhaar && <span className="error text-danger">The field is required</span>}
                                    </div>
                                </div>
                                <div className='col-sm-6 col-md-4 col-lg-4'>
                                    <div className="form-group">
                                        <label>Mobile Number</label>
                                        <input type="text" className={`form-control normal-light ${getDataError && getDataError.mobile ? "is-invalid" : ""}`} name="mobile" value={getDataField && getDataField.mobile} onKeyDown={isNumber} onChange={(e) => onChangeValue(e)} maxLength={10} ref={mobileInput} />{getDataError && getDataError.mobile && <span className="error text-danger">The field is required</span>}
                                    </div>
                                </div>
                                <div className='col-sm-12 col-md-12 col-lg-12'>
                                    <div className='form-group'>
                                        <Checkbox className='d-flex' checked={isConsent === "Y" ? true : false} onChange={onChangeChackBox}>I hereby give my voluntary consent to SR PAY Private Limited, use my Aadhaar/ VID number & biometric to authenticate from UIDAI for the purpose of AEPS activation.</Checkbox>
                                    </div>
                                </div>
                                <div className='col-sm-12 col-md-12 col-lg-12'>
                                    <div className='col-sm-4 col-md-4 col-lg-4'>
                                        <BioDevice />
                                    </div>
                                </div>
                                <div className='col-sm-6 col-md-4 col-lg-4'>
                                    <label></label>
                                    <div className='col-md-12 d-flex'>
                                        <div className="form-group  pull-right text-lg-right mr-4">
                                            <button type="submit" className="btn btn-default rounded-pill pl-4 pr-4" onClick={() => clearFormField()} >Cancel</button>
                                        </div>
                                        <div className="form-group text-lg-right">
                                            <button type="submit" className="btn btn-primary rounded-pill pl-4 pr-4" onClick={() => scanFinger()} disabled={isConsent === 'N' ? true : false} ><i class="fas fa-fingerprint"></i> Scan Finger</button>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BalanceEnquiry